module.exports = __webpack_public_path__ + "static/media/all-stage-locked.ac8762a3.png";